export default "__VITE_ASSET__BMCIKI9s__"